/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import RichTextEditorInput from 'components/organisms/RichTextEditor/RichTextEditorInput';
import {
  EditorState, convertToRaw, convertFromRaw
} from 'draft-js';
import markdownToDraft from 'services/markdownToDraft'
import draftToMarkdown from 'services/draftToMarkdown'
import { richTextEditorOptions } from 'types'
import { useDebouncedCallback } from 'use-debounce';

const RichTextEditorMarkdownInput = (
  {
    initialMarkdown, onEditorStateChange, options, onBlur, toolbar
  }
) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  // convert markdown to draftjs EditorState
  useEffect(() => {
    const rawDraftObj = markdownToDraft(initialMarkdown || ' ', {
      blockTypes: {},
      blockEntities: {}
    })
    const newEditorState = EditorState.createWithContent(convertFromRaw(rawDraftObj))
    setEditorState(newEditorState)
  }, [initialMarkdown])

  // convert EditorState to markdown
  const debouncedConvertMarkdown = useDebouncedCallback(
    (newEditorState) => {
      const contentState = newEditorState.getCurrentContent()
      const rawDraftObj = convertToRaw(contentState)
      const markdownFromEditorState = draftToMarkdown(rawDraftObj);
      onEditorStateChange(markdownFromEditorState)
    },
    400);

  const handleChange = (newEditorState) => {
    setEditorState(newEditorState)
    debouncedConvertMarkdown(newEditorState)
  }

  return (
    <RichTextEditorInput
      editorState={editorState}
      onEditorStateChange={handleChange}
      options={options}
      onBlur={onBlur}
      toolbar={toolbar}
    />
  )
}

RichTextEditorMarkdownInput.propTypes = {
  editorState: PropTypes.shape({}),
  initialMarkdown: PropTypes.string,
  onEditorStateChange: PropTypes.func,
  onBlur: PropTypes.func,
  options: richTextEditorOptions,
  toolbar: PropTypes.arrayOf(PropTypes.string)
}

RichTextEditorMarkdownInput.defaultProps = {
  editorState: EditorState.createEmpty(),
  initialMarkdown: '',
  onEditorStateChange: () => null,
  onBlur: () => null,
  options: {},
  toolbar: undefined,
}

export default RichTextEditorMarkdownInput;
